import { selectFromAll, selectFromCurrentCELs } from './dictionary'

export const selectConventionalPMI = selectFromCurrentCELs(
  'conventionalPmiMonthlyTotal'
)
export const selectEstimatedPMI = selectFromCurrentCELs(
  'estimatedPmiMonthlyTotal'
)
export const selectLTVPercent = selectFromCurrentCELs('ltvPercent')
export const showPMIContainer = selectFromAll('showPmiSection')
